<mat-form-field class="dict-deregistration-packs">
  <mat-select [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event)"
              [multiple]="multiple" [placeholder]="label">
    <mat-option>
      <ngx-mat-select-search [formControl]="deregistrationPackFilterCtrl" placeholderLabel="Wyszukaj..."
                             noEntriesFoundLabel="Nie znaleziono paczek">
      </ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let deregistrationPack of items"
                [value]="deregistrationPack.uuid">
      {{deregistrationPack.insuranceCompany.name}} {{deregistrationPack.createdAt | date:'y-MM-dd'}}
    </mat-option>
  </mat-select>
  <button *ngIf="((control.value !== null
    && multiple && control.value.hasOwnProperty('length')
    && control.value.length > 0) || (!multiple && control.value))
    && !required"
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Clear"
          (click)="clearValue(); $event.stopPropagation()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
</mat-form-field>
